import { UserCreditCardRequest } from "./book-payment.request";

export class ShoppingCartPostRequest {
  // Delivery Address
  deliveryZipcode: string;
  deliveryAddress: string;
  deliveryNumber: string;
  deliveryComplement: string | null;
  deliveryNeighborhood: string;
  deliveryCity: string;
  deliveryState: string;
  deliveryType: string;
  deliveryPrice: number | undefined | null;
  finalPrice: number
  idPaymentMethod: number;
  cpfPix: string;
  idPaymentMethodInstallment: number | null;
  userCreditCard: UserCreditCardRequest | null;

  kits: ShoppingCartKitItemRequest[];

  constructor() {
    this.kits = [];
  }
}

export class ShoppingCartKitItemRequest {
  idKit: number;
  quantity: number;
  finalPriceUnit: number;
  priceUnit: number;
  discountAuthorCode: string | null;
  priceDeliveryTotal: number | null | undefined;
}